import { render, staticRenderFns } from "./addFolder.vue?vue&type=template&id=72b4fa81&"
import script from "./addFolder.vue?vue&type=script&lang=js&"
export * from "./addFolder.vue?vue&type=script&lang=js&"
import style0 from "./addFolder.vue?vue&type=style&index=0&id=72b4fa81&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports